import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getUnreadNotificationCount } from '../../services/notificationService';
import { isNativeApp } from '../../utils/platformUtils';

const POLL_MS = 30_000;
const UNREAD_EVENT = 'rintintin:notif-unread';

/** Compteur notifications non lues — polling natif uniquement (no-op web). */
export function useNativeNotificationCount(): number {
  const { isAuthenticated } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!isNativeApp() || !isAuthenticated) {
      setCount(0);
      return;
    }
    const n = await getUnreadNotificationCount();
    setCount(n);
  }, [isAuthenticated]);

  useEffect(() => {
    void refresh();
    if (!isNativeApp() || !isAuthenticated) return;

    const id = window.setInterval(() => void refresh(), POLL_MS);
    const onPublished = (ev: Event) => {
      const detail = (ev as CustomEvent<number>).detail;
      if (typeof detail === 'number' && Number.isFinite(detail)) {
        setCount(Math.max(0, detail));
      }
    };
    window.addEventListener(UNREAD_EVENT, onPublished);
    return () => {
      window.clearInterval(id);
      window.removeEventListener(UNREAD_EVENT, onPublished);
    };
  }, [refresh, isAuthenticated]);

  return count;
}
